export const enum State {
  PLACEHOLDER,
  LOADING,
  LOADED,
  FAILED,
}
